import req from './axios.js' //引入封装好的axios
//*****************************基础请求的头部和地址信息***************************
var http = "http://"
var isLocal = false //设置是否本机



const path = window.config.apiPath
console.log("接口地址：" + window.config.apiPath)
const appId = window.config.appId
console.log("应用编码：" + appId)

// const mesPath = isLocal ? "" : path //mes请求路径 

export const basePath = path;
//**********************************************************  头部的请求接口地址 start ***************************************//
//获取平台配置信息
export const getPlatConfigInfo = (params, callback) => req(path + "/amc/api/open/apply/platConfig", 'get', params, callback)
export const checkPhone = (params, callback) => req(path + '/amc/api/open/user/checkPhone', 'get', params, callback);
export const sendCodeToPhone = (params, callback) => req(path + '/mmc/api/open/msg/verificationCodeToPhone?phone=' + params.phone, 'post', params, callback);
export const phoneTokenLogin = (params, callback) => req(path + '/amc/phone/token?phone=' + params.phone + '&code=' + params.code, 'post', {}, callback);
export const getUserInfo = (params, callback) => req(path + '/amc/api/token/user/getUserInfo', 'get', params, callback);
export const getUserCompany = (params, callback) => req(path + '/amc/api/token/user/getUserCompany', 'get', params, callback);
export const getUserDept = (params, callback) => req(path + '/amc/api/token/companyDept/deptUserType', 'get', params, callback);
export const getSettingByCode = (params, callback) => req(path + '/ccm/api/saas/companySetting/code', 'get', params, callback);

//**********************************************************  首页 ***********************************************************//

//获取当前用户在该企业下可见的App应用菜单
export const myCompanyApplys = (params, callback) => req(path + '/amc/api/token/user/getUserCompanyApplyMenu?applyId=' + appId, 'get', params, callback);
// export const myCompanyApplys = (params, callback) => req(path + '/amc/api/token/user/getUserCompanyApplyMenu?applyId=577859156669628416', 'get', params, callback);
// 获取组织架构人员信息
export const getPersonnelList = (params, callback) => req(path + '/amc/api/token/companyUser/allUserInfo?isProduct=0', 'get', params, callback)
export const getCompanyUserInfoByUserName = (params, callback) => req(path + '/amc/api/token/companyUser/getCompanyUserInfoByUserName', 'get', params, callback)


//**********************************************************  登录 ***********************************************************//
//获取字典集合
export const getDictPageList = (params, callback) => req(path + '/ccm/api/saas/basicBaseDicts/selectDictPageList', 'get', params, callback)
//*************************************
//密码加盐
export const checkPwd = (params, callback) => req(path + '/amc/api/open/user/checkPwd', 'get', params, callback);
//登录
export const uniLogin = (params, callback) => req(path + '/amc/password/token?username=' + params.username + '&password=' + params.password, 'post', params, callback);


//*********************************************************  制单管理  *******************************************************//
//制造单查询
export const getDlorder = (params, callback) => req(path + '/mes/api/saas/dl/order', 'get', params, callback);
// 新增汇报
export const addOrderNodeReport = (params, callback) => req('/mes/api/saas/dl/orderNodeReport', 'post', params, callback);
// 根据当前用户ID和节点类型查询节点列表
export const getForReport = (params, callback) => req(path + '/mes/api/saas/dl/orderNode/getForReport', 'get', params, callback);
//根据制造单id查出完整数据
export const getOrder = (params, callback) => req(path + '/mes/api/saas/dl/order/' + params.id, 'get', params, callback);
//根据唯一值查出完整数据
export const getByOrderCode = (params, callback) => req(path + '/mes/api/saas/dl/order/getByOrderCode', 'get', params, callback);
//保存数据
export const saveOrderNodeReport = (params, callback) => req(path + '/mes/api/saas/dl/orderNodeReport', 'post', params, callback);
// 上传附件
export const uploadMesPic = (params, callback) => req(path + '/mes/api/saas/upload/mesPic', 'post', params, callback);
// 查询模杯工单
export const getMBGDByOrderCode = (params, callback) => req(path + "/mes/api/saas/dl/braCup/selectByOrderCode", "get", params, callback);

//*********************************************************  制单进度  *******************************************************//
//查询节点汇报详情
export const getOrderNodeByPage = (params, callback) => req(path + '/mes/api/saas/dl/orderNodeReport/getOrderNodeByPage', 'get', params, callback);
export const queryOrderNumAsColorSize = (params, callback) => req(path + '/mes/api/saas/dl/orderNodeReport/queryOrderNumAsColorSize', 'get', params, callback);


//*********************************************************  扫菲报工  *******************************************************//
// 计划查询
export const getNodePlan = (params, callback) => req(path + '/mes/api/saas/dl/order/nodePlan', 'get', params, callback);
// 根据当前用户ID查询节点列表
export const getOrderNode = (params, callback) => req(path + '/mes/api/saas/dl/orderNode', 'get', params, callback);
// 根据当前用户ID和节点id查询节点
export const getByOrderNode = (params, callback) => req(path + '/mes/api/saas/dl/orderNode/' + params, 'get', null, callback);
//查询节点的排程排位工序
export const getNodeStationProcedure = (params, callback) => req(path + '/mes/api/saas/layoutVersionStation/getNodeStationProcedure', 'get', params, callback);
//获取上一节点汇报总数和当前节点工序汇报数量
export const getQueryOrderNodeSituation = (params, callback) => req(path + '/mes/api/saas/dl/order/queryOrderNodeSituation', 'get', params, callback);
//判断不选总床次颜色尺码是否汇报过
export const getQueryWorkTicketReport = (params, callback) => req(path + '/mes/api/saas/dl/orderNodeReport/queryWorkTicketReport', 'get', params, callback);
// 根据裁床id查询颜色尺码所对应所有菲票
export const getQueryByCutId = (params, callback) => req(path + '/mes/api/saas/cut/bed/queryByCutId', 'get', params, callback);


//*********************************************************  手动报工  *******************************************************//
// 手工报工节点完成
export const saveCompluteOrderNode = (params, callback) => req(path + '/mes/api/saas/dl/orderNodeReport/compluteOrderNode', 'patch', params, callback);
//查询色码明细表
export const getQuerynextNodeProcessNum = (params, callback) => req(path + '/mes/api/saas/dl/order/querynextNodeProcessNum', 'get', params, callback);
// 查询模具信息
export const getMouldListByMoldId = (params, callback) => req(path + "/mes/api/saas/molded/byIdBatch", "get", params, callback);



//*********************************************************  汇报记录  *******************************************************//
// 汇报记录
export const getOrderNodeReport = (params, callback) => req(path + '/mes/api/saas/dl/orderNodeReport', 'get', params, callback);
// 删除汇报记录
export const deleteOrderNodeReport = (params, callback) => req(path + '/mes/api/saas/dl/orderNodeReport/deleteOrderNodeReport?id='+params.id, 'delete', params, callback);
//根据id查询汇报记录详情
export const getOrderNodeReportById = (params, callback) => req(path + '/mes/api/saas/dl/orderNodeReport/' + params, 'get', null, callback);
//保存汇报记录
export const updateOrderNodeReport = (params, callback) => req(path + '/mes/api/saas/dl/orderNodeReport', 'put', params, callback);


//********************************************************* 工资   *******************************************************//
//员工工资
export const getLayoutTotalDept = (params, callback) => req(path + '/mes/api/saas/sewn/layoutTotalDept', 'get', params, callback);
//工资详情
export const getLayoutTotal = (params, callback) => req(path + '/mes/api/saas/sewn/layoutTotal', 'get', params, callback);
//获取审核信息
export const getLayoutSubmitDept = (params, callback) => req(path + '/mes/api/saas/sewn/layoutSubmitDept', 'get', params, callback);
//提交
export const updateSewnConfirm = (params, callback) => req(path + '/mes/api/saas/sewn/sewnConfirm', 'post', params, callback);
//工资详情
export const getLayoutSubmit = (params, callback) => req(path + '/mes/api/saas/sewn/layoutSubmit', 'get', params, callback);
//主管查询组员记录
export const getLayoutDeptWages = (params, callback) => req(path + '/mes/api/saas/sewn/layoutDeptWages', 'get', params, callback);





//*********************************************************  裁床管理  *******************************************************//
// 裁床单查询
export const getSelectReduceBedListDl = (params, callback) => req(path + '/mes/api/saas/dl/reduce/selectReduceBedListDl', 'get', params, callback);
// 花边明细或裁片明细
export const getColorSize = (params, callback) => req(path + '/mes/api/saas/dl/reduce/workTicket/' + params, 'get', null, callback);
//菲票明细
export const getWorkTicketFP = (params, callback) => req(path + '/mes/api/saas/dl/reduce/workTicketFP/' + params, 'get', null, callback);
//裁床单汇报
export const addChangeStatus = (params, callback) => req(path + '/mes/api/saas/dl/reduce/changeStatus', 'patch', params, callback);
// 拉布汇报
export const saveCuttingSheetReport = (params, callback) => req(path + '/mes/api/saas/dl/reduce/cuttingSheetReport', 'post', params, callback);



//*********************************************************  装箱管理  *******************************************************//

// 查询装箱单列表
export const getSelectReduceBedPacking = (params, callback) => req(path + '/mes/api/saas/dl/reduce/selectReduceBedPacking', 'get', params, callback);
// 装箱详情
export const getselectReduceBedPackingDetails = (params, callback) => req(path + '/mes/api/saas/dl/reduce/selectReduceBedPackingDetails', 'get', params, callback);
// 装箱详情删除
export const deleteReduceBedPackingDetails = (params, callback) => req(path + '/mes/api/saas/dl/reduce/deleteReduceBedPackingDetails', 'delete', params, callback);
//装箱删除
export const deleteReduceBedPacking = (params, callback) => req(path + '/mes/api/saas/dl/reduce/deleteReduceBedPacking', 'delete', params, callback);
// 新增查询(扫描菲票)
export const getworkTicket = (params, callback) => req(path + '/mes/api/saas/dl/reduce/workTicket', 'get', params, callback);
// 装箱新增
export const saveInsertReduceBedPacking = (params, callback) => req(path + '/mes/api/saas/dl/reduce/insertReduceBedPacking', 'post', params, callback);
//根据菲票id查询装箱数据
export const selectReduceBedPackingDetailsById = (params, callback) => req(path + '/mes/api/saas/dl/reduce/selectReduceBedPackingDetailsById', 'get', params, callback);



//*********************************************************  供应商管理  *******************************************************//
// 获取供应商列表
export const getSupplierByPage = (params, callback) => req(path + '/ccm/api/saas/srmFactorys/getSupplierByPage', 'get', params, callback);
// 根据供应商id查询信息
export const getSrmAllById = (params, callback) => req(path + '/ccm/api/saas/srmFactorys/getCrmAllById', 'get', params, callback);
//保存供应商信息
export const updateSupplier = (params, callback) => req(path + '/ccm/api/saas/srmFactorys/updateSrm', 'PATCH', params, callback);
//修改供应商状态
export const updaSrmStatus = (params, callback) => req(path + '/ccm/api/saas/srmFactorys/updaCrmStatus', 'PATCH', params, callback);



//*********************************************************  客户管理  *******************************************************//
// 获取客户信息
export const getcrmCustoms = (params, callback) => req(path + '/ccm/api/saas/crmCustoms', 'get', params, callback);
// 根据供应商id查询信息
export const getCrmAllById = (params, callback) => req(path + '/ccm/api/saas/crmCustoms/getCrmAllById', 'get', params, callback);
//保存供应商信息
export const updateUpdateCrm = (params, callback) => req(path + '/ccm/api/saas/crmCustoms/updateUpdateCrm', 'PATCH', params, callback);
//修改供应商状态
export const updaCrmStatus = (params, callback) => req(path + '/ccm/api/saas/crmCustoms/updaCrmStatus', 'PATCH', params, callback);


//*********************************************************  外发管理  *******************************************************//
// 创建外发单
export const saveOutOrder = (params, callback) => req(path + '/mes/api/saas/outOrder', 'post', params, callback);
// 外发列表
export const getOutOrder = (params, callback) => req(path + '/mes/api/saas/outOrder/page', 'get', params, callback);
//根据id查询外发订单详情
export const getOutOrderById = (params, callback) => req(path + '/mes/api/saas/outOrder/' + params, 'get', null, callback);
//更新生产订单状态（接单和拒单）
export const updateaOrderStatus = (params, callback) => req(path + '/mes/api/saas/order', 'PUT', params, callback);


//*********************************************************  裁床收料 *******************************************************//
// 收料详情页
export const queryHanverstWorkTicket = (params, callback) => req(path + '/mes/api/saas/dl/reduce/queryHanverstWorkTicket', 'get', params, callback);
// 收料详情页-扫二维码
export const receivingScanning = (params, callback) => req(path + `/mes/api/saas/dl/reduce/receivingScanning/${params.id}`, 'get', params, callback);


//*********************************************************  品质检验 *******************************************************//
export const getPunchs = (params, callback) => req(path + '/ccm/api/saas/punch/punchs', 'post', params, callback);
// 查询任务
export const getBills = (params, callback) => req(path + '/tqm/api/saas/bills', 'get', params, callback);

export const getBillsID = (params, callback) => req(path + '/tqm/api/saas/bills/' + params, 'get', null, callback);

export const getByIds = (params, callback) => req(path + '/mes/api/saas/order/byIds?ids=' + params, 'get', null, callback);

export const getBoardsByWorkId = (params, callback) => req(path + '/tqm/api/saas/check/boardsByWorkId?workId=' + params, 'get', null, callback);

export const getStyleSizeMethods = (params, callback) => req(path + '/tqm/api/saas/standard/styleSizeMethods/', 'get', params, callback);

export const getBadReasonList = (params, callback) => req(path + '/tqm/api/saas/check/getBadReasonList', 'get', params, callback);

export const getStyleStandard = (params, callback) => req(path + '/tqm/api/saas/standard/styleStandard?lang=zh_CN&_t=15809645430&pageNum=1&pageSize=1000&workId=' + params, 'get', null, callback);

export const getTechnologyByBillCode = (params, callback) => req(path + '/pms/api/saas/pms/technologyByBillCode', 'get', params, callback);

export const getSaasOrder = (params, callback) => req(path + '/mes/api/saas/order/' + params, 'get', null, callback);

export const postBillProcesss = (params, callback) => req(path + '/tqm/api/saas/billProcesss', 'post', params, callback);

export const postState = (params, callback) => req(path + '/tqm/api/saas/bills/state', 'post', params, callback);

export const getBillProcesss = (params, callback) => req(path + '/tqm/api/saas/billProcesss/getById/' + params, 'get', null, callback);
//检验标准
export const SelectDictByType = (params, callback) => req(path + '/ccm/api/saas/basicBaseDicts/selectDictByType?type=crmpackagingMaterial', 'get', params, callback);

export const getByName = (params, callback) => req(path + '/tqm/api/saas/checkTypes/getByName?name=' + params, 'get', null, callback);


//*********************************************************  图片库 *******************************************************//
// 花型库列表接口
export const getPatternLibrary = (params, callback) => req(path + '/pdm/api/saas/patternLibrary' + params, 'get', null, callback);
//花型库新增或者修改接口
export const postPatternLibrary = (params, callback) => req(path + '/pdm/api/saas/patternLibrary', 'post', params, callback);
// 花型库查询详情接口
export const getPatternLibraryById = (params, callback) => req(path + '/pdm/api/saas/patternLibrary/' + params, 'get', null, callback);
//图片素材分类
export const getTree = (params, callback) => req(path + '/pdm/api/saas/group/tree?groupName=图片素材分类', 'get', params, callback);




//*********************************************************  领料管理 *******************************************************//
// 领料列表接口
export const getPickOrder = (params, callback) => req(path + '/mes/api/saas/pickOrder', 'get', params, callback);
// 新增领料单信息
export const postPickOrder = (params, callback) => req(path + '/mes/api/saas/pickOrder', 'post', params, callback);
// 修改领料单信息
export const patchPickOrder = (params, callback) => req(path + '/mes/api/saas/pickOrder', 'PATCH', params, callback);
// 根据ID查询领料单
export const getPickOrderById = (params, callback) => req(path + '/mes/api/saas/pickOrder/' + params, 'get', null, callback);
// 查询制造单的物料需求
export const getQueryMaterialNeed = (params, callback) => req(path + '/mes/api/saas/order/queryMaterialNeed', 'get', params, callback);
// 根据制造单编号查询当前每卷编号最大数
export const getQueryMaxReelNo = (params, callback) => req(path + '/mes/api/saas/pickOrder/queryMaxReelNo', 'get', params, callback);



//*********************************************************  松布管理 *******************************************************//
// 松布列表接口
export const selectLooseFabricData = (params, callback) => req(path + '/mes/api/saas/dl/order/selectLooseFabricData', 'get', params, callback);
// 根据ID查询领料单
export const selectLooseFabricDataById = (params, callback) => req(path + '/mes/api/saas/dl/order/selectLooseFabricDataById', 'get', params, callback);
// 查询制造单的物料需求
export const selectMaterialDataById = (params, callback) => req(path + '/mes/api/saas/dl/order/selectMaterialDataById', 'get', params, callback);
//修改松布数据
export const updateLooseFabricData = (params, callback) => req(path + '/mes/api/saas/dl/order/updateLooseFabricData', 'post', params, callback);
//新增松布数据
export const insertLooseFabricData = (params, callback) => req(path + '/mes/api/saas/dl/order/insertLooseFabricData', 'post', params, callback);
// 查询松布幅宽
export const selectLooseClothDetailsData = (params, callback) => req(path + '/mes/api/saas/dl/order/selectLooseClothDetailsData', 'get', params, callback);


//*********************************************************  拉布管理 *******************************************************//
// 拉布列表接口
export const getSpreadOrder = (params, callback) => req(path + '/mes/api/saas/spreadOrder', 'get', params, callback);
// 根据ID查询拉布单
export const getSpreadOrderById = (params, callback) => req(path + '/mes/api/saas/spreadOrder/' + params, 'get', null, callback);
// 根据制造单编号查询松布单物料明细
export const getQueryLooseCloth = (params, callback) => req(path + '/mes/api/saas/spreadOrder/queryLooseCloth', 'get', params, callback);
// 新增拉布单信息
export const postSpreadOrder = (params, callback) => req(path + '/mes/api/saas/spreadOrder', 'post', params, callback);
// 修改拉布单信息
export const patchSpreadOrder = (params, callback) => req(path + '/mes/api/saas/spreadOrder', 'PATCH', params, callback);

// 根据库位码查询库位
export const getWarehouseData = (params, callback) => req(path + '/mes/api/saas/order/getWarehouseData', 'get', params, callback);

export const updateLooseFabricWidthOfCloth = (params, callback) => req(path + '/mes/api/saas/dl/order/updateLooseFabricWidthOfCloth', 'get', params, callback);



//*********************************************************  QC管理 *******************************************************//
export const getCheckBillList = (params, callback) => req(path + '/tqm/api/saas/tqm/checkBillList', 'get', params, callback);
export const getCheckBillTotalById = (params, callback) => req(path + '/tqm/api/saas/tqm/checkBillTotal', 'get', params, callback);
//根据制版单号带出尺寸表
export const getQueryPlateStyleSize = (params, callback) => req(path + '/pms/api/saas/v2/pms/queryPlateStyleSize', 'get', params, callback);
//根据订单编号跟工厂款号带出尺寸表
export const getQueryStyleSize = (params, callback) => req(path + '/pms/api/saas/bigGoodsBom/queryStyleSize', 'get', params, callback);



//获取疵点列表
export const getCheckDefectList = (params, callback) => req(path + '/tqm/api/saas/tqm/checkDefectList', 'get', params, callback);
//保存数据
export const saveCheckBill = (params, callback) => req(path + '/tqm/api/saas/tqm/checkBill', 'post', params, callback);
//查询检验记录
export const getCheckBill = (params, callback) => req(path + '/tqm/api/saas/tqm/checkBill', 'get', params, callback);
//打卡
export const saveClockIn = (params, callback) => req(path + '/tqm/api/saas/tqm/clockIn', 'post', params, callback);
//查询打卡列表
export const getClockInList = (params, callback) => req(path + '/tqm/api/saas/tqm/clockInList', 'get', params, callback);
//完成
export const changCheckBill = (params, callback) => req(path + '/tqm/api/saas/tqm/checkBill?id=' + params, 'patch', null, callback);


//*********************************************************  包装报工*******************************************************//
// 查询包装派工数据
export const getPackOrderDispatchApp = (params, callback) => req(path + '/mes/api/saas/pack/getPackOrderDispatchApp', 'get', params, callback);
// 查询包装派工详细数据
export const getPackOrderDispatchDetailApp = (params, callback) => req(path + '/mes/api/saas/pack/getPackOrderDispatchDetailApp', 'get', params, callback);
// 扫描包装派工菲票App
export const scanPackOrderDispatchApp = (params, callback) => req(path + '/mes/api/saas/pack/scanPackOrderDispatchApp', 'get', params, callback);
// 提交包装派工扫菲数据App
export const submitPackOrderDispatchApp = (params, callback) => req(path + '/mes/api/saas/pack/submitPackOrderDispatchApp', 'post', params, callback);




//*********************************************************  装箱报工*******************************************************//
//  装箱派工列表
export const selectEncaseDispatch = (params, callback) => req(path + '/mes/api/saas/encase/selectEncaseDispatch', 'get', params, callback);
// 装箱派工明细
export const encaseDispatchDetail = (params, callback) => req(path + '/mes/api/saas/encase/encaseDispatchDetail', 'get', params, callback);
// 装箱派工提交
export const workReport = (params, callback) => req(path + '/mes/api/saas/encase/workReport', 'post', params, callback);




//*********************************************************  制单进度 *******************************************************//
export const gewtSummaryProcedureNum = (params, callback) => req(path + '/mes/api/saas/dl/orderNodeReport/summaryProcedureNum', 'get', params, callback);


//*********************************************************  PDM审核列表 *******************************************************//
export const getAudit = (params, callback) => req(path + '/aps/api/saas/audit/getAudit', 'get', params, callback);
//通过审核
export const approved = (params, callback) => req(path + '/aps/api/saas/audit/approved', 'post', params, callback);

export const getMapping = (params, callback) => req(path + '/aps/api/token/auditModule/mapping', 'GET', params, callback);

//*********************************************************  全生命周期 *******************************************************//
// 列表接口
export const getFullLifeCircleList = (params, callback) => req(path + "/aps/api/saas/orderBillStyle/queryOrderBillStyleColorList", "get", params, callback);
// 详情接口
export const getFullLifeCircleDetailById = (params, callback) => req(path + "/aps/api/saas/orderBillStyle/queryOrderBillStyleColorDetails", "get", params, callback);
// 查询折叠面板列表详细数据
export const getFaceAccessoriesKittingVoInfoById = (params, callback) => req(path + "/aps/api/saas/orderBillStyle/queryFaceAccessoriesKittingVoInfo", "get", params, callback);
// 保存接口
export const saveFullLifeCircleDetail = (params, callback) => req(path + '/aps/api/saas/orderNodes/updateOrderNode', 'post', params, callback);
// 保存接口 - 列表形式
export const saveFullLifeCircleDetailList = (params, callback) => req(path + "/aps/api/saas/orderNodes/updateOrderNodeByColorNodeIdList", "post", params, callback);
// 获取裁数汇报尺码数据
export const getDispatchFactoryColorSizeNumList = (params, callback) => req(path + "/aps/api/saas/orderBillStyle/queryDispatchFactoryColorSizeNumList", "get", params, callback);
// 保存裁数汇报明细数据
export const saveOrderNodeColorSizeNums = (params, callback) => req(path + "/aps/api/saas/orderNodeColorSizeNums", "post", params, callback);
// 获取款式下的所有工厂数据
export const getCustomNameListById = (params, callback) => req(path + "/aps/api/saas/orderBillStyle/queryCustomNameListByIsCropping", "get", params, callback);
// 获取工厂对应数据
export const getProducePlanByWorkBillId = (params, callback) => req(path + "/aps/api/saas/orderNodeProducePlans/queryOrderNodeProducePlanByWorkBillId", "post", params, callback);
// 保存生产进度跟踪接口 - 列表形式
export const saveOrderNodeProducePlanIdList = (params, callback) => req(path + "/aps/api/saas/orderNodeProducePlans/updateOrderNodeProducePlanIdList", "post", params, callback);
// 获取实裁汇报明细日志
export const getColorSizeNumLogByWorkBillId = (params, callback) => req(path + "/aps/api/saas/orderNodeColorSizeNumLogs/selectOrderNodeColorSizeNumLogVOList", "get", params, callback);
// 撤销实裁数
export const revokeColorSizeNum = (params, callback) => req(path + "/aps/api/saas/orderNodeColorSizeNumLogs/revokeStatus?id=" + params.id, "post", params, callback);

//*********************************************************  采购管理 *******************************************************//
// 获取采购申请列表
export const getPurchaseList = (params, callback) => req(path + "/wms/api/saas/stockRequisition/stockRequisitions", "get", params, callback);
// 获取采购申请单详情
export const getPurchaseDetailsById = (params, callback) => req(path + "/wms/api/saas/stockRequisition/stockRequisitionItem", "get", params, callback);
// 作废采购申请单
export const deletePurchase = (params, callback) => req(path + "/wms/api/saas/stockRequisition/voidStockRequisitions?ids=" + params, "delete", null, callback);
// 获取仓库列表
export const getWarehouseList = (params, callback) => req(path + "/wms/api/saas/warehouse/normalWarehouses", "get", params, callback);
// 获取人员列表
export const getUserList = (params, callback) => req(path + "/amc/api/token/companyUser/users", "get", params, callback);
// 判断是否已生成过采购单
export const getIsCreatePurchase = (params, callback) => req(path + "/wms/api/saas/stockRequisition/checkRepeatByStockReq", "get", params, callback);
// 生成采购单
export const saveCreatePurchase = (params, callback) => req(path + "/wms/api/saas/purchasing/createPurchaseByStockReq", "post", params, callback);
// 获取物料数据列表
export const getMaterialList = (params, callback) => req(path + "/wms/api/saas/goodsInfo/goodsInfo", "get", params, callback);
// 获取单据类型列表
export const getDocumentTypeList = (params, callback) => req(path + "/ccm/api/saas/basicBaseDicts/selectDictByTypes?type=stockRequisitionDocumentType", "get", params, callback);
// 保存采购申请单
export const savePurchase = (params, callback) => req(path + "/wms/api/saas/stockRequisition/stockRequisitions", "post", params, callback);
// 编辑保存采购申请单
export const updatePurchase = (params, callback) => req(path + "/wms/api/saas/stockRequisition/updateStockRequisitions", "post", params, callback);
// 获取供应商列表
export const getSupplierList = (params, callback) => req(path + "/ccm/api/saas/srmFactorys/getSupplierByPage", "get", params, callback);
// 获取采购需求池列表
export const getMergePurchaseList = (params, callback) => req(path + "/wms/api/saas/stockRequisitionPlan/v4/stockRequisitionGoods", "get", params, callback);
// 判断是否生成过重复采购单
export const checkRepeatByMerge = (params, callback) => req(path + "/wms/api/saas/stockRequisition/checkRepeatByMerge", "post", params, callback);
// 生成采购单
export const createPurchase = (params, callback) => req(path + "/wms/api/saas/purchasing/mergePurchase", "post", params, callback);
// 获取采购单列表
export const getPurorderList = (params, callback) => req(path + "/wms/api/saas/purchasing/purchasings", "get", params, callback);
// 获取采购单详情
export const getPurorderDetailsById = (params, callback) => req(path + "/wms/api/saas/purchasing/purchasingsById", "get", params, callback);
// 保存采购单
export const savePurorder = (params, callback) => req(path + "/wms/api/saas/purchasing/purchasings", "post", params, callback);
// 编辑保存采购单
export const editSavePurorder = (params, callback) => req(path + "/wms/api/saas/purchasing/updatePurchasing", "post", params, callback);
// 作废采购单
export const deletePurorder = (params, callback) => req(path + "/wms/api/saas/purchasing/voidPurchasing?ids=" + params, "delete", null, callback);
// 获取分享供应商token - 用于供应商可查看采购单详情数据
export const getTokenByPurorder = (params, callback) => req(path + "/wms/api/open/purchasing/getToken", "get", params, callback);
// 获取分享供应商采购单详情数据
export const getPurorderDetailsByTokenId = (params, callback) => req(path + "/wms/api/open/purchasing/purchasingsById", "get", params, callback);
// 获取单位列表
export const getUnitList = (params, callback) => req(path + "/ccm/api/saas/unitConfig", "get", params, callback);
// 获取订单交货计划列表
export const getOrderDeliveryScheduleList = (params, callback) => req(path + "/wms/api/saas/deliveryDocument", "get", params, callback);
// 获取订单交货计划详情
export const getOrderDeliveryScheduleDetailsById = (params, callback) => req(path + "/wms/api/saas/deliveryDocument/getInfo", "get", params, callback);
// 新增交货计划获取采购单列表
export const getPurchasingList = (params, callback) => req(path + "/wms/api/saas/purchasing/purchasings", "get", params, callback);
// 获取新增交货计划导入的采购单详情
export const getPurchasingDetailsById = (params, callback) => req(path + "/wms/api/saas/purchasing/purchasingInfo", "get", params, callback);
// 获取新增交货计划导入的采购单详情中的物料款式数据
export const getStyleInfoByBillList = (params, callback) => req(path + "/wms/api/saas/deliveryDocument/getStyleInfoByBillStyleId", "get", params, callback);
// 保存新增交货计划
export const saveOrderDeliverySchedule = (params, callback) => req(path + "/wms/api/saas/deliveryDocument", "post", params, callback);
// 作废交货计划
export const deleteOrderDeliverySchedule = (params, callback) => req(path + "/wms/api/saas/deliveryDocument/voidReceipts?ids=" + params, "delete", null, callback);

//*********************************************************  模杯装箱 *******************************************************//
// 查询模杯装箱单列表
export const getSelectBraCupPacking = (params, callback) => req(path + '/mes/api/saas/dl/braCupPacking', 'get', params, callback);
// 模杯装箱删除
export const deleteBraCupPacking = (params, callback) => req(path + '/mes/api/saas/dl/braCupPacking/deleteBraCupPacking', 'delete', params, callback);
// 模杯装箱明细删除
export const deleteBraCupPackingDetail = (params, callback) => req(path + '/mes/api/saas/dl/braCupPacking/deleteBraCupPackingDetail', 'delete', params, callback);
// 模杯装箱查询详情
export const getSelectBraCupPackingDetail = (params, callback) => req(path + '/mes/api/saas/dl/braCupPacking/selectBraCupPackingDetail', 'get', params, callback);
//根据制卡明细id查询模杯装箱
export const selectBraCupPackingDetailByCardId = (params, callback) => req(path + '/mes/api/saas/dl/braCupPacking/selectBraCupPackingDetailByCardId', 'get', params, callback);
// 模杯装箱新增
export const insertBraCupPacking = (params, callback) => req(path + '/mes/api/saas/dl/braCupPacking/insertBraCupPacking', 'post', params, callback);
// 查询制卡明细
export const getSmartCardById = (params, callback) => req(path + '/mes/api/saas/dl/braCup/smartCardById', 'get', params, callback);

//*********************************************************  品检登记-成品 *******************************************************//
// 获取品检登记-成品列表
export const getFinishedProductInspectionList = (params, callback) => req(path + "/wms/api/saas/finishedProductInspections/getFinishedProductInspectionList", "post", params, callback);
// 检验单（成品） - 详情
export const finishedProductInspectionsDetails = (params, callback) => req(path + "/wms/api/saas/finishedProductInspections/getDetails?id=" + params.id, "get", null, callback);
// 反审核检验单-成品
export const unExamineFinishedProductInspections = (params, callback) => req(path + "/wms/api/saas/finishedProductInspections/deApprovalSubmit", "post", params, callback);
// 操作日志
export const getBizLogList = (params, callback) => req(path + "/ccm/api/saas/bizLog/getPageList", "post", params, callback);
// 获取检验方案列表
export const getInspectionSchemeList = (params, callback) => req(path + "/wms/api/saas/v2/inspectionScheme/getPageList", "post", params, callback);
// 获取抽检方案列表
export const getSamplingPlanList = (params, callback) => req(path + "/wms/api/saas/samplingPlans/getPageList", "post", params, callback);
// 查看抽样方案 - 详情
export const samplingPlansDetails = (params, callback) => req(path + "/wms/api/saas/samplingPlans/getById?id=" + params.id, "get", null, callback);
// 检验方案 - 详情
export const inspectionSchemeDetails = (params, callback) => req(path + "/wms/api/saas/v2/inspectionScheme/getById?id=" + params.id, "get", null, callback);
// 获取缺陷名称列表
export const getDefectNameList = (params, callback) => req(path + "/wms/api/saas/qualityInspectionDefectss/getPageList", "post", params, callback);
// 获取缺陷等级列表
export const getDefectLevelList = (params, callback) => req(path + "/ccm/api/saas/basicBaseDicts/selectDictByTypesPage", "get", params, callback);
// 获取系统参数 - 是否隐藏颜色 / 规格
export const getCompanySettingByColorCode = (params, callback) => req(path + "/ccm/api/saas/companySetting/code", "get", params, callback);
// 检验单（成品） - 保存
export const saveFinishedProductInspections = (params, callback) => req(path + "/wms/api/saas/finishedProductInspections/save", "post", params, callback);
// 检验单（成品） - 提交
export const submitFinishedProductInspections = (params, callback) => req(path + "/wms/api/saas/finishedProductInspections/submit", "post", params, callback);
// 获取品检登记-物料列表
export const getInspectionSheetList = (params, callback) => req(path + "/wms/api/saas/inspectionSheet/getPageList", "post", params, callback);
// 检验单（物料） - 详情
export const inspectionSheetDetails = (params, callback) => req(path +"/wms/api/saas/inspectionSheet/getDetails?id="+params.id, "get", null, callback);
// 检验单（物料） - 保存
export const saveInspectionSheet = (params, callback) => req(path + "/wms/api/saas/inspectionSheet/save", "post", params, callback);
// 检验单（物料） - 提交
export const submitInspectionSheet = (params, callback) => req(path + "/wms/api/saas/inspectionSheet/submit", "post", params, callback);
// 反审核检验单-物料
export const unExamineMaterialProductInspections = (params, callback) => req(path + "/wms/api/saas/inspectionSheet/deApprovalSubmit", "post", params, callback);
// 检验单（物料） - 外观/理化状态更新
export const inspectionStatusUpdate = (params, callback) => req(wms_http + "/api/saas/inspectionSheet/inspectionStatusUpdate?id=" + params.id + '&type=' + params.type + '&status=' + params.status, "get", null, callback);
// 获取质检人员列表
export const getCheckUserList = (params, callback) => req(path + "/amc/api/token/companyUser/usersByPost", "get", params, callback);
//*********************************************************  包装报工new *******************************************************//
// 包装报工列表
export const getPackagingWorkOrder = (params, callback) => req(path + '/mes/api/saas/packaging/getPackagingWorkOrder', 'get', params, callback);
// 根据id包装报工详情
export const getPackagingWorkOrderById = (params, callback) => req(path + '/mes/api/saas/packaging/getPackagingWorkOrderById', 'get', params, callback);
// 包装报工节点汇报
export const reportPackingWorkOrder = (params, callback) => req(path + '/mes/api/saas/packaging/reportPackingWorkOrder', 'post', params, callback);
//获取已汇报接口
export const alreadyReportPackagingNum = (params, callback) => req(path + '/mes/api/saas/packaging/alreadyReportPackagingNum', 'get', params, callback);

//*********************************************************  审批管理 *******************************************************//
// 审批管理待办列表
export const getTodoList = (params, callback) => req(path + "/flowable/api/saas/task/todoList", "get", params, callback);
// 审批管理已办列表
export const getFinishedList= (params, callback) => req(path + "/flowable/api/saas/task/finishedList", "get", params, callback);
// 审批通过
export const submitComplete= (params, callback) => req(path + "/flowable/api/saas/task/complete?taskId="+params.taskId+'&instanceId='+params.instanceId+'&comment='+params.comment, "post", params, callback);
// 审批驳回
export const submitReject= (params, callback) => req(path + "/flowable/api/saas/task/reject?taskId="+params.taskId+'&instanceId='+params.instanceId+'&comment='+params.comment, "post", params, callback);
// 付款单审批详情
export const getPaymentOrderById = (params, callback) => req(path + "/fms/api/saas/paymentOrder/getPaymentOrderById", "get", params, callback);
// 预付单审批
export const getReceivableDetailsById = (params, callback) => req(path + "/fms/api/saas/prepaidOrder/getReceivableDetailsById", "get", params, callback);
// 付款单审批记录
export const getFlowRecord = (params, callback) => req(path + "/flowable/api/saas/task/flowRecord", "get", params, callback);
//根据id查询应付单详情
export const getPayableDetailsById = (params, callback) => req(path + "/fms/api/saas/payableDetails/getPayableDetailsById", "get", params, callback);
// 根据id获取关联业务单号列表
export const getOriginalOrderListById = (params, callback) => req(path + "/fms/api/saas/originalOrder/getOriginalOrderListById", "get", params, callback);
 // 根据id获取物料明细数据
export const getOriginalOrderItemList = (params, callback) => req(path + "/fms/api/saas/originalOrder/getOriginalOrderItemList", "get", params, callback);
// 委外订单审核根据id查询详情
export const getProductOutgoingOrderById = (params, callback) => req(path + "/aps/api/saas/productOutgoingOrder/"+params.id, "get", null, callback);
// 核价单根据id查询详情
export const getPricingById = (params, callback) => req(path + "/cos/api/saas/pricing/getById", "get", params, callback);
//核价单查询报价币种数据
export const getPricingRemplateById = (params, callback) => req(path + "/ccm/api/saas/pricingRemplate/"+params.id, "get", params, callback);
//供应商根据id获取详情
export const geSrmFactorysById = (params, callback) => req(path + "/ccm/api/saas/srmFactorys/getCrmAllById", "get", params, callback);
// 采购单根据id查询详情
export const getPurchasingByIdHs = (params, callback) => req(path + "/wms/api/saas/purchasing/getPurchasingByIdHs", "get", params, callback);
// 采购单关联单据信息根据id查询详情
export const getDetailByOrderId = (params, callback) => req(path + "/wms/api/saas/purchasing/getDetailByOrderId", "get", params, callback);
// 采购单委外关联单据信息根据id查询详情
export const getProductOutgoingOrder= (params, callback) => req(path + "/aps/api/saas/productOutgoingOrder/getDetailByOrderId", "get", params, callback);


//*********************************************************  组检管理 *******************************************************//
// 扫菲获取数据
export const getInfoByTicketCode = (params, callback) => req( path + "/mes/api/saas/inspectionOrder/getInfoByTicketCode/"+params.code+'/'+params.orderType, "get", null, callback);
// 获取缺陷分类数据
export const getDefectTypeList= (params, callback) => req(path + "/ccm/api/saas/basicBaseDicts/selectDictByTypes?type=defectType", "get", params, callback);
// 获取所有缺陷数据
export const getQualityInspectionDefectss = (params, callback) => req(path + '/wms/api/saas/qualityInspectionDefectss/getPageList', 'post', params, callback);
// 保存不合格数据
export const postSignDetail = (params, callback) => req(path + '/mes/api/saas/inspectionOrder/signDetail', 'post', params, callback);
// 删除缺陷记录
export const deleteOrderDetail= (params, callback) => req(path + "/mes/api/saas/inspectionOrder/deleteOrderDetail/"+params.detailId, "get", null, callback);




